import { useCallback } from "react";
import { store } from "src/redux/store";
import {
  type IsAutosaveBlockedOptions,
  selectIsAutosaveBlocked,
} from "src/redux/selectors/selectIsAutosaveBlocked";
import { useDispatch } from "src/redux/hooks";

import { triggerAutosaveForExternalChange } from "./autosaveScheduler";

export const useTriggerAutoSave = () => {
  const dispatch = useDispatch();
  return useCallback(
    (options?: IsAutosaveBlockedOptions) => {
      if (selectIsAutosaveBlocked(store.getState(), options)) return;
      triggerAutosaveForExternalChange(dispatch, options);
    },
    [dispatch],
  );
};
